export interface SystemTask {
  taskName: string;
  systemTaskId: string;
  parametersDescription: string;
  returnsDescription: string;
  category: string;
}
